export const CONSTANTS = {
  AUTH_RESULT: 'auth-result',
  LAST_RATING_DATE: 'last-rating',
  LAST_ANTRAG_CREATION_DATE: 'last-antrag-creation',
  LOGIN_DATA: 'login-data',
  PIN_KEY: 'pin',
  PRIVACY_SCREEN_KEY: 'privacy-screen',
  SAVE_BIOMETRIC_KEY: 'biometric',
  SAVE_TELEMETRY_KEY: 'telemetry',
  SHARED_FILE_URL: 'shared-file-url',
  SEND_INTENT_RECEIVED: 'send-intent-received',
  USERDATA: 'user-data',
};
